export default function arrayEquals(a, b) {
    return a.every(item => b.includes(item)) && b.every(item => a.includes(item))
}
